import {
    Input as FormControl,
    Checkbox as NCCheckbox,
    Switch as NCSwitch,
    NumberInput as NCNumber,
    // NCInput,
    // NCMessage,
    Select,
    // NCSelectBetween,
    Radio as NCRadio,
    // NCBetweenNum,
    // NCRow as Row,
    Col,
    Dropdown,
    Tooltip as NCTooltip,
    Timepicker as NCTimepicker,
    DatePicker as NCDatePicker,
    RangePickerClient as NCRangePicker,
    RangePicker,
    DatePickerClient as NCDatePickerClient,
    DateTimePickerBetween as NCDateTimePickerBetween,
    TZDatePickerStart as NCTZDatePickerStart,
    TZDatePickerRangeDay as NCTZDatePickerRangeDay,
    TZDatePickClientHourTime as NCTZDatePickClientHourTime,
    TZDatePickClientTime as NCTZDatePickClientTime,
    TZDatePickerEnd as NCTZDatePickerEnd,
    TZDatePickerStartBetween as NCTZDatePickerStartBetween,
    TZDatePickerEndBetween as NCTZDatePickerEndBetween,
    MultiLangText as NCMultiLangText,
    Refer,
    BetweenInput,
    BetweenNum as NCBetweenNum,
    SelectBetween as NCSelectBetween,
    getFunctionDisplay,
} from '@platform/base';
// import { PubSub } from '@platform/api';
const { ReferLoader } = Refer;
// import toast from '../../api/toast';
import { moment, getSysFieldid, isFunction, isArray, isEmpty, isObject, PubSub, formatDatetime, formatNumber, getBusinessInfo, compareTimeFunction, serverTimeToLocal, localTimeToServer, microAppUtil } from '@platform/api';
import { getFunctionValueFromViewModal, isDateFunction, tree2Array } from './_methods';
import TipsSearchItem from './TipsSearchItem';
import React from 'react';
require('./createSearch.less');

const Option = Select.Option;
const CheckboxGroup = NCCheckbox.CheckboxGroup;
/**
 * 数据类型和组件类型配合对应的itemtype
 *
 * 字符—文本输入框："input"
 * 字符-静态文本："label" -----查询区不支持
 * 多语文本："residtxt"
 * 整数，小数，金额："number"
 * 大文本："textarea"
 * 密码框："password"
 * 附件："attachment"  -----查询区不支持
 * 主键："input"
 * 自定义项：input
 * 自由辅助属性："input"
 *
 *
 * 参照："refer"   ----------模板配置方式 eg:参照名称：工种(自定义档案)
 * 自定义档案："refer"   ----------模板配置方式 eg:参照名称：工种(自定义档案)
 *
 * //options可以配,没配的话就没有option
 * 枚举-单选："radio"   ----在没勾多选的情况下，模板会加一个空的选项,options: [{display: "", value: ""}, {display: "锁定", value: "Y"}, {display: "未锁定", value: "N"}]
 * 枚举-复选："checkbox"  -----options: [{display: "锁定", value: "Y"}, {display: "未锁定", value: "N"}]
 * 枚举-下拉："select"  ----在没勾多选的情况下，模板会加一个空的选项,options: [{display: "", value: ""}, {display: "锁定", value: "Y"}, {display: "未锁定", value: "N"}]
 *
 * //options不能配
 * 逻辑-单选："radio"  ----模板会加一个空的选项, options: [{display: "", value: ""}, {display: "是", value: "Y"}, {display: "否", value: "N"}]
 * 逻辑-复选："checkbox" ---- options: [{display: "是", value: "Y"}, {display: "否", value: "N"}]
 * 逻辑-开关："switch"  ----模板会加一个空的选项, options: [{display: "", value: ""}, {display: "是", value: "Y"}, {display: "否", value: "N"}]
 * 逻辑-停启用开关："switch_browse"   ----模板会加一个空的选项   -----查询区不支持
 * 逻辑-开关型复选框："checkbox_switch"   ----模板会加一个空的选项
 *
 * 开始日期："NCTZDatePickerStart"
 * 结束日期："NCTZDatePickerEnd"
 * 日期："datepicker"
 * 日期时间："datetimepicker"
 * 无时区："datePickerNoTimeZone"
 *
 */
class templateEngine {
    constructor({
        moduleId,
        searchInfo,
        snapshotItem,
        isAdvDom = false,
        onAfterEvent,
        onBeforeEvent,
        setStateEve,
        renderItem,
        showRequire = true,
        context = {},
        showPlaceholder = true,
        multiLang,
        LangData,
        parentRef,
        clickSearch,
        hiddenFunList,
        showLableFlag,
        showSearchLable = true,
        onOperateTypeChange,
        status,
        searchPlanNum = '000',
        containerRef,
        underlineBorder,
    }) {
        this.templetItem = searchInfo.itemsMap[snapshotItem.attrcode];
        this.containerRef = containerRef;
        this.onOperateTypeChange = onOperateTypeChange;
        let businessInfo = getBusinessInfo();
        this.Date = businessInfo
            ? moment(businessInfo.businessDate).format('YYYY-MM-DD')
            : moment().format('YYYY-MM-DD');
        // this.Date = '2020-10-20';
        if (!this.templetItem) {
            //toast({ content: '查询方案损坏！', color: 'warning' });

            return null;
        }

        Object.assign(this, {
            moduleId,
            searchInfo,
            isAdvDom,
            snapshotItem,
            onAfterEvent,
            onBeforeEvent,
            setStateEve,
            renderItem,
            showRequire,
            context,
            showPlaceholder,
            multiLang,
            LangData,
            parentRef,
            clickSearch,
            hiddenFunList,
            showLableFlag,
            showSearchLable,
            searchPlanNum,
            status,
            underlineBorder,
        });
        this.clearRquiredWraning( this.templetItem );

        return this.createTemplateItemDom();
    }

    //  事件触发清除警告 通过全局的事件订阅发布 绕开了徐洋之前的逻辑(类组件内部状态处理有问题)
    //  采用全局事件订阅发布的方式 可能存在问题 待处理
    clearRquiredWraning(item) {
        let status = this.status;
        if (item) {
            PubSub.publish('clearWarning_' + this.moduleId, {
                data: item.attrcode,
                status,
                moduleId: this.moduleId,
            });
        }
    }

    trustString(data) {
        if (typeof data === 'string') {
            return formatNumber(data, true);
        } else if (Array.isArray(data)) {
            return data
                .filter(item => item)
                .map(item => formatNumber(item, true))
                .join(',');
        }
    }

    isTrueEmpty(data) {
        if (isEmpty(data)) {
            return true;
        } else if (Array.isArray(data)) {
            return data.filter(item => item).length === 0;
        }
    }

    //获得查询条件的操作符的展示
    getQueryOperateDisplay(queryOperateType) {
        let result = '';
        if (queryOperateType) {
            queryOperateType = queryOperateType.replace(/^@+|@$/g, '');
            let opt = queryOperateType.split('@')[0];
            switch (opt) {
                case '<>':
                    result = '≠';
                    break;
                case '<':
                    result = '<';
                    break;
                case '>':
                    result = '>';
                    break;
                case '>=':
                    result = '≥';
                    break;
                case '<=':
                    result = '≤';
                    break;
            }
        }

        return result;
    }

    /* 编辑后事件 */
    onAfterEve(field, val, index, oldValue) {
        if (index == undefined) {
            index = 0;
        }
        if (isFunction(this.onAfterEvent)) {
            // code value modleID operationSign betweenIndex
            this.onAfterEvent(
                field,
                val,
                this.moduleId,
                this.snapshotItem.operationSign,
                index,
                oldValue,
            );
        }
    }

    //input输入改变,更新state
    onInputChange(item, val) {
        this.clearRquiredWraning(item);
        let oldValue = this.snapshotItem?.initialvalue?.value || '';
        this.snapshotItem.initialvalue.value = val;
        this.snapshotItem.initialvalue.display = val; //xuyangt 2018/11/20添加
        this.setStateEve(
            this.onAfterEve.bind(
                this,
                item.attrcode,
                val,
                0,
                oldValue,
                'onchange',
            ),
        );
    }

    /* input失去焦点事件 */
    inputBlur(item, type, val) {
        let oldValue = this.snapshotItem?.initialvalue?.value || '';
        if (type === 'number' || type === 'input') {
            this.snapshotItem.initialvalue.value = val;
        }
        this.setStateEve(
            this.onAfterEve.bind(
                this,
                item.attrcode,
                val,
                0,
                oldValue,
                'onblur',
            ),
        );
    }

    //select改变，更新state
    onSelectedChange(item, val) {
        this.clearRquiredWraning(item);
        let oldValue = this.snapshotItem?.initialvalue?.value || '';
        if (val === '__clear__' || val === undefined || val === '') {
            // 清空
            if (val === undefined) {
                val = '';
            }
            this.snapshotItem.initialvalue = {
                value: '',
                display: '',
            };
        } else {
            this.snapshotItem.initialvalue = {
                value: val,
                display: item.options.find(i => i.value == val).display,
            };
        }
        this.setStateEve(
            this.onAfterEve.bind(
                this,
                item.attrcode,
                val === '__clear__' ? undefined : val,
                0,
                oldValue,
            ),
        );
    }

    onSelectedBetweenChange(item, i, val) {
        if (val === undefined) {
            val = '';
        }
        let oldValue = this.snapshotItem?.initialvalue?.value || '';
        this.clearRquiredWraning(item);
        let data = this.snapshotItem;
        if (
            data.initialvalue.display &&
            !Array.isArray(data.initialvalue.display)
        ) {
            data.initialvalue.display = data.initialvalue.display.split(',');
        }
        data.initialvalue.display = data.initialvalue.display || [];
        data.initialvalue.value = data.initialvalue.value || [];
        data.initialvalue.display[i] =
            item.options.find(i => i.value == val)?.display || '';
        data.initialvalue.value[i] = val;
        this.setStateEve(
            this.onAfterEve.bind(
                this,
                item.attrcode,
                data.initialvalue.value,
                i,
                oldValue,
            ),
        );
    }

    /* select多选 */
    onMultipleChange(item, val = []) {
        let oldValue = this.snapshotItem?.initialvalue?.value || '';
        this.clearRquiredWraning(item);
        let opt = item.options;
        let valuelist = opt.filter(vv => val.some(v => vv.value == v));
        this.snapshotItem.initialvalue = {
            display: valuelist.map(vv => vv.display).join(','),
            value: valuelist.map(vv => vv.value).join(','),
        };
        this.setStateEve(
            this.onAfterEve.bind(
                this,
                item.attrcode,
                this.snapshotItem.initialvalue.value,
                0,
                oldValue,
            ),
        );
    }

    onDateSelect(data) {}

    //日期选择事件
    onDateChange(item, date, display) {
        let oldValue = this.snapshotItem?.initialvalue?.value || '';
        this.clearRquiredWraning(item);
        if (typeof date === 'string' || !date) {
            // if (date.indexOf('#') > -1) {
            //     let datePart = date.split(' ');
            //     this.snapshotItem.initialvalue.value = datePart[0];
            // }
            this.snapshotItem.initialvalue.value = date;
        } else if (typeof date === 'object') {
            if (Array.isArray(date)) {
                this.snapshotItem.initialvalue.value = date;
            } else {
                this.snapshotItem.initialvalue.value = date.value;
            }
        }
        this.snapshotItem.initialvalue.display = date;
        let value = Array.isArray(display) ? display[0] : display;
        this.setStateEve(
            this.onAfterEve.bind(this, item.attrcode, value, 0, oldValue),
        );
    }

    onDateTimeBetweenChange(item, value, display) {
        let oldValue = this.snapshotItem?.initialvalue?.value || '';
        this.clearRquiredWraning(item);
        let data = this.snapshotItem;
        data.initialvalue.value = value || [];
        data.initialvalue.display = value || [];
        //判断是否initialvalue是数组
        if (!Array.isArray(value)) {
            data.initialvalue.value = data.initialvalue.value.split(',');
            data.initialvalue.display = data.initialvalue.value;
        }
        let date = [];
        if (Array.isArray(display)) {
            if (Array.isArray(display[0])) {
                date.push(display[0][0]);
            } else {
                date.push(display[0]);
            }
            if (Array.isArray(display[1])) {
                date.push(display[1][1]);
            } else {
                date.push(display[1]);
            }
        }
        let val = { value: date, display: date };
        this.setStateEve(
            this.onAfterEve.bind(this, item.attrcode, val, 0, oldValue),
        );
    }

    //区间类型日期事件
    onRangDateChange(item, date, display) {
        let oldValue = this.snapshotItem?.initialvalue?.value || '';
        this.clearRquiredWraning(item);
        this.snapshotItem.initialvalue.value = date || [];
        this.snapshotItem.initialvalue.display = date || [];
        let value = [];
        if (Array.isArray(display)) {
            if (Array.isArray(display[0])) {
                value.push(display[0][0]);
            } else {
                value.push(display[0]);
            }
            if (Array.isArray(display[1])) {
                value.push(display[1][1]);
            } else {
                value.push(display[1]);
            }
        }
        let val = { value: value, display: value };
        this.setStateEve(
            this.onAfterEve.bind(this, item.attrcode, val, 0, oldValue),
        );
    }

    //参照更改事件
    referChangeEve(item, val, foolValue, config) {
        let oldValue = this.snapshotItem?.initialvalue?.value || '';
        this.clearRquiredWraning(item);
        if (Array.isArray(val)) {
            val.forEach(vv => {
                let VALUE = { display: vv.refname, value: vv.refpk };
                if (vv.isValid !== false) {
                    VALUE = getFunctionValueFromViewModal(
                        { display: vv.refname, value: vv.refpk },
                        this.context,
                    );
                } else {
                    VALUE = { display: '', value: '' };
                }
                vv.refname = VALUE.display;
                vv.refpk = VALUE.value;
                this.snapshotItem.runWithChildren = vv.runWithChildren;
                this.snapshotItem.refurl = vv.queryTreeUrl;
            }, this);
        } else {
            let VALUE = getFunctionValueFromViewModal(
                { display: val.refname, value: val.refpk },
                this.context,
            );
            val.refname = VALUE.display;
            val.refpk = VALUE.value;
        }
        this.snapshotItem.initialvalue = { ...foolValue, ...val };
        if(!isEmpty(config)){
            this.snapshotItem.referConfig = config;
        }
        this.setStateEve(
            this.onAfterEve.bind(this, item.attrcode, val, 0, oldValue),
        );
    }

    betweenReferChangeEve(i, item, value, foolValue, config) {
        let oldValue = this.snapshotItem?.initialvalue?.value || '';
        this.clearRquiredWraning(item);
        let data = this.snapshotItem;

        data.initialvalue.display = data.initialvalue.display || [];
        data.initialvalue.value = data.initialvalue.value || [];
        data.initialvalue.display[i] = foolValue.display;
        data.initialvalue.value[i] = foolValue.value;
        data.runWithChildren = value.runWithChildren;
        if (Array.isArray(value)) {
            value.forEach(vv => {
                let VALUE = getFunctionValueFromViewModal(
                    { display: vv.refname, value: vv.refpk },
                    this.context,
                    item.attrcode,
                );
                vv.refname = VALUE.display;
                vv.refpk = VALUE.value;
                this.snapshotItem.runWithChildren = vv.runWithChildren;
                this.snapshotItem.refurl = vv.queryTreeUrl;
                if(!isEmpty(config)){
                    this.snapshotItem.referConfig = config;
                }
            }, this);
        }
        this.setStateEve(
            this.onAfterEve.bind(this, item.attrcode, value, i, oldValue),
        );
    }

    //单选change事件
    radioChange(item, val) {
        let oldValue = this.snapshotItem?.initialvalue?.value || '';
        this.clearRquiredWraning(item);
        this.snapshotItem.initialvalue.value = val;
        this.setStateEve(
            this.onAfterEve.bind(this, item.attrcode, val, 0, oldValue),
        );
    }

    // checkbox_switch 事件
    onChangeCheckbox_switch(item, e) {
        let oldValue = this.snapshotItem?.initialvalue?.value || '';
        this.clearRquiredWraning(item);
        if (item.disabled) {
            return;
        }
        e.stopPropagation();
        let value = !this.snapshotItem.initialvalue.value;
        this.snapshotItem.initialvalue.value = value;
        this.setStateEve(
            this.onAfterEve.bind(this, item.attrcode, value, 0, oldValue),
        );
    }

    //开关事件
    switchChange(item) {
        let oldValue = this.snapshotItem?.initialvalue?.value || '';
        this.clearRquiredWraning(item);
        let value = !this.snapshotItem.initialvalue.value;
        this.snapshotItem.initialvalue.value = value;
        this.setStateEve(
            this.onAfterEve.bind(this, item.attrcode, value, oldValue),
        );
    }

    // 数字类型事件
    changeNumber(item, data) {
        let oldValue = this.snapshotItem?.initialvalue?.value || '';
        if (Array.isArray(data)) {
            if (data[0] || data[1]) {
                this.clearRquiredWraning(item);
            }
        } else {
            if (!isEmpty(data)) {
                this.clearRquiredWraning(item);
            }
        }
        this.snapshotItem.initialvalue.value = data;
        this.snapshotItem.initialvalue.display = data;
        this.setStateEve(
            this.onAfterEve.bind(
                this,
                item.attrcode,
                this.snapshotItem.initialvalue.value,
                0,
                oldValue,
            ),
        );
    }

    //对最大值和最小值进行合法性校验
    checkNumberHandler(data) {
        let result = true;
        let propList = ['min', 'max'];
        if (propList.every(item => data.hasOwnProperty(item))) {
            if (data.max < data.min) {
                result = false;
                console.error('错误：最小值大于最大值');
            }
        }

        return result;
    }

    onMultiLangTextChange(item, data) {
        let oldValue = this.snapshotItem?.initialvalue?.value || '';
        this.clearRquiredWraning(item);
        let value = '';
        // xiquanquan
        for (const key in data) {
            if (data.hasOwnProperty(key)) {
                data[key].index = data[key].index || '1';
                if (data[key].index == this.snapshotItem.initialvalue.index) {
                    this.snapshotItem.initialvalue = {
                        value: data[key].value,
                        display: data[key].value,
                        index: data[key].index,
                    };
                    value = data[key].value;
                    break;
                }
            }
        }
        this.snapshotItem.valueMap = data;
        this.setStateEve(
            this.onAfterEve.bind(this, item.attrcode, value, 0, oldValue),
        );
    }

    onMultiLangTextSelect(item, value, index) {
        let oldValue = this.snapshotItem?.initialvalue?.value || '';
        this.clearRquiredWraning(item);
        this.snapshotItem.initialvalue = {
            value,
            index,
            display: value,
        };
        if (!this.snapshotItem.valueMap) {
            this.snapshotItem.valueMap = {};
            this.snapshotItem.valueMap[this.snapshotItem.attrcode + index] = { value };
        }
        this.setStateEve(
            this.onAfterEve.bind(this, item.attrcode, value, 0, oldValue),
        );
    }

    onCustomChange(item, val) {
        let oldValue = this.snapshotItem?.initialvalue?.value || '';
        console.log(item, val, '自定义render编辑后事件');
        let { value = '', display = '' } = val;
        this.clearRquiredWraning(item);
        this.snapshotItem.initialvalue = {
            value,
            display,
        };
        this.setStateEve(
            this.onAfterEve.bind(this, item.attrcode, value, 0, oldValue),
        );
    }

    getCondition = (data, searchInfo, context) => {
        let relyConditon = [];
        if (data.refcondition) {
            let refcondition = JSON.parse(data.refcondition);
            if (isArray(refcondition)) {
                refcondition.forEach(e => {
                    if (isObject(e) && e.key && e.value) {
                        if (e.valueType && e.valueType !== 'field') {
                            relyConditon.push(e);
                        } else {
                            let snapshot_list = tree2Array(
                                searchInfo?.snapshotMap?.[searchInfo.status] ||
                                    [],
                            );
                            let refItem = snapshot_list.find(
                                i => i.attrcode === e.value,
                            );
                            let val = refItem?.initialvalue || {
                                display: '',
                                value: '',
                            };
                            val = getFunctionValueFromViewModal(val, context);
                            if (val.value) {
                                e.value = val.value;
                                relyConditon.push(e);
                            }
                        }
                    }
                });
            }
        }
        return relyConditon;
    };

    getItemPopContainer = () => {
        let { searchInfo, containerRef } = this;
        if (searchInfo.status === 'simple') {
            return microAppUtil.getDocument().querySelector('.workbench-grid-layout-container') || microAppUtil.getDocument();
        }
        // return containerRef || microAppUtil.getDocument();
        return microAppUtil.getDocument();
    }

    createTemplateItemDom() {
        let {
            showLableFlag,
            snapshotItem,
            templetItem,
            renderItem,
            multiLang,
            LangData,
            hiddenFunList,
            isAdvDom,
            searchInfo,
            showSearchLable,
        } = this;
        let that = this;
        let data = templetItem;
        const referConfig = snapshotItem.referConfig || {};
        let isconverttimezones = data.isconverttimezones;
        const disabledOperationSign = ['is null', 'is not null'];
        let disabled = data.disabled;
        if (
            disabledOperationSign.some(
                item => item === snapshotItem.operationSign,
            )
        ) {
            disabled = true;
        }
        if (data.render) {
            data.itemtype = 'custom';
        }
        let val;
        let initialvalue = snapshotItem.initialvalue || {
            display: '',
            value: '',
        };
        let type = data.itemtype || '';
        let hiddenfunlist = hiddenFunList[snapshotItem.attrcode];
        let showTimeFunction = true;
        if (hiddenfunlist === true) {
            showTimeFunction = false;
        } else if (hiddenfunlist === undefined) {
            hiddenfunlist = [];
        }
        if (type === 'switch') {
            type = 'checkbox_switch';
        }
        if (
            type === 'datepicker' ||
            type === 'NCTZDatePickerEnd' ||
            type === 'NCTZDatePickerStart' ||
            type === 'datePickerNoTimeZone'
        ) {
            if (
                snapshotItem.hasOwnProperty('operationSign') &&
                (snapshotItem.operationSign === 'between' ||
                    snapshotItem.operationSign === 'not between')
            ) {
                type = 'rangepicker';
            }
        } else if (type === 'textarea') {
            type = 'input';
        } else if (type === 'radio' || type === 'checkbox') {
            type = 'select';
        } else if (
            type === 'NCTZDatePickClientHourTime' ||
            type === 'NCTZDatePickClientTime'
        ) {
            if (
                snapshotItem.hasOwnProperty('operationSign') &&
                (snapshotItem.operationSign === 'between' ||
                    snapshotItem.operationSign === 'not between')
            ) {
                type = 'datetimepicker';
            }
        }
        if (
            type === 'datepicker' &&
            snapshotItem.hasOwnProperty('operationSign')
        ) {
            if (
                snapshotItem.operationSign === '>' ||
                snapshotItem.operationSign === '<='
            ) {
                type = 'NCTZDatePickerEnd';
            } else if (
                snapshotItem.operationSign === '<' ||
                snapshotItem.operationSign === '>='
            ) {
                type = 'NCTZDatePickerStart';
            }
        }
        if (type === 'select' || type === 'radio' || type === 'checkbox') {
            //多选 val为 数组['1','4']； 单选val为字符串 ’1‘
            //兼容错误数据
            if (type === 'radio') {
                data.isMultiSelectedEnabled = false;
            }
            if (type === 'checkbox') {
                data.isMultiSelectedEnabled = true;
            }
            if (data.isMultiSelectedEnabled) {
                val = initialvalue.value
                    ? String(initialvalue.value).split(',')
                    : [];
                initialvalue.display = [];
                if (templetItem.options) {
                    val.forEach(v => {
                        initialvalue.display.push(
                            templetItem.options.find(o => o.value == v)
                                ?.display || '',
                        );
                    });
                }
                initialvalue.display = initialvalue.display.join(',');
            } else {
                if (
                    (snapshotItem.operationSign === 'between' ||
                        snapshotItem.operationSign === 'not between') &&
                    type === 'select'
                ) {
                    if (Array.isArray(initialvalue.value)) {
                        val = initialvalue.value;
                    } else {
                        val = [];
                    }
                } else {
                    val = String(initialvalue.value) || '';
                    if(val === 'undefined'){
                        val = '';
                    }
                }
            }
        } else if (type === 'checkbox') {
            // val = initialvalue.value ? String(initialvalue.value).split(',') : '';
        } else if (type === 'checkbox_switch') {
            val = initialvalue.value || false;
        } else if (type === 'datepicker') {
            typeof initialvalue.value === 'string'
                ? (val = initialvalue.value)
                : (val = '');
        } else if (
            type === 'rangepicker' ||
            ((type === 'datetimepicker' ||
                type === 'NCTZDatePickerEnd' ||
                type === 'NCTZDatePickerStart') &&
                (snapshotItem.operationSign === 'between' ||
                    snapshotItem.operationSign === 'not between'))
        ) {
            if (Array.isArray(initialvalue.value)) {
                val = initialvalue.value;
            } else if (initialvalue.value) {
                val = initialvalue.value.split(',');
            } else {
                val = [];
            }
        } else {
            if (
                snapshotItem.operationSign !== 'between' &&
                snapshotItem.operationSign !== 'not between'
            ) {
                val =
                    (initialvalue || {}).value || (initialvalue || {}).display;
            } else {
                val = Array.isArray(initialvalue.value)
                    ? initialvalue.value
                    : String(initialvalue.value).split(',');
            }
        }
        if (
            (type === 'datepicker' ||
                type === 'NCTZDatePickerEnd' ||
                type === 'NCTZDatePickerStart') &&
            snapshotItem.operationSign === '='
        ) {
            if (Array.isArray(initialvalue.value)) {
                val = initialvalue.value[0] || '';
            }
        }

        //  必输项标识
        let mustFillInLable = null;
        let mustFillIn1 = null;
        let mustFillIn2 = null;
        if( data.required && this.showRequire && !snapshotItem.remove ){
            if (showLableFlag) {
                mustFillInLable = (
                    <span className="mustFillIn_search-lable iconfont icon-xinghao"></span>
                );
            }else{
                mustFillIn1 = (
                    <span className="mustFillIn_search1 iconfont icon-xinghao"></span>
                );
                let betweenType = [
                    'refer',
                    'select',
                    'datetimepicker',
                    'number',
                    'input',
                ];
                if ((snapshotItem.operationSign === 'between' || snapshotItem.operationSign === 'not between') &&
                    betweenType.includes(type)){
                    mustFillIn2 = (
                        <span className="mustFillIn_search2 iconfont icon-xinghao"></span>
                    );
                }
            }
        }
       
        let searchChildDom = null;
        // 查询条件的tip值
        let fieldTip = '';
        let timeValue = '';
        let optText = that.getQueryOperateDisplay(data.queryOperateType);
        let label = isAdvDom ? data.advLable || data.label : data.label;
        data.placeholder =
            this.showPlaceholder && (!showLableFlag || !showSearchLable)
                ? label + optText
                : '';
        if (!data.hasOwnProperty('maxlength')) {
            data.maxlength = Infinity;
        }

        switch (type) {
            case 'refer':
                let refData = initialvalue,
                    referDom = null;
                if (refData && isEmpty(refData)) {
                    refData = {
                        display: '',
                        value: '',
                    };
                }
                if (renderItem[data.attrcode]) {
                    referDom = renderItem[data.attrcode];
                }
                let funcs = data.functions;
                if (Array.isArray(funcs)) {
                    funcs.forEach(element => {
                        element.value = element
                            ? getFunctionValueFromViewModal(
                                {
                                    value: element.code,
                                    display: element.name,
                                },
                                this.context,
                                data.attrcode,
                            ).value
                            : '';
                    });
                }

                let refDisplay = '';
                if (
                    snapshotItem.hasOwnProperty('operationSign') &&
                    snapshotItem.operationSign === 'between'
                ) {
                    let queryCondition = data.queryCondition;
                    let queryCondition1 = {},
                        queryCondition2 = {};
                    if (Array.isArray(queryCondition)) {
                        queryCondition1.queryCondition = queryCondition[0];
                        queryCondition2.queryCondition = queryCondition[1];
                    } else if (queryCondition) {
                        queryCondition1.queryCondition = queryCondition;
                        queryCondition2.queryCondition = queryCondition;
                    }
                    let VALUE = [];
                    //兼容业务赋值报错
                    if (refData.value && typeof refData.value === 'string') {
                        refData.value = refData.value.split(',');
                    }
                    if (
                        refData.display &&
                        typeof refData.display === 'string'
                    ) {
                        refData.display = refData.display.split(',');
                    }
                    VALUE = (refData.value || []).map((v, index) => {
                        let vv = {
                            value: v,
                            display: refData.display
                                ? refData.display[index]
                                : '',
                        };
                        return getFunctionValueFromViewModal(
                            vv,
                            this.context,
                            data.attrcode,
                        );
                    });
                    refDisplay = VALUE.map(v => v.display).join(',');
                    let vv = {
                        value: '',
                        display: '',
                    };
                    if (referDom) {
                        referDom = {
                            ...referDom,
                            props: {
                                // dropDownContainer: this.getItemPopContainer,
                                ...referDom.props,
                                ...data,
                                placeholder: data.placeholder,
                                foolValue: {
                                    ...initialvalue,
                                    ...(isEmpty(VALUE) ? vv : VALUE[0]),
                                },
                                onChange: that.betweenReferChangeEve.bind(
                                    that,
                                    '0',
                                    data,
                                ),
                                showTitle: false,
                            },
                        };
                    }
                    searchChildDom = (
                        <div
                            className="between-refer"
                            fieldid={getSysFieldid(data.attrcode)}
                        >
                            <div className="startRefer between-refer-item">
                                {referDom || (
                                    <ReferLoader
                                        {...referConfig}
                                        {...data}
                                        {...queryCondition1}
                                        refRelyCondition={() => {
                                            return this.getCondition(
                                                data,
                                                searchInfo,
                                                this.context,
                                            );
                                        }}
                                        placeholder={data.placeholder}
                                        foolValue={{
                                            ...initialvalue,
                                            ...(isEmpty(VALUE[0])
                                                ? vv
                                                : VALUE[0]),
                                        }}
                                        onChange={that.betweenReferChangeEve.bind(
                                            that,
                                            '0',
                                            data,
                                        )}
                                        showTitle={false}
                                        // dropDownContainer={this.getItemPopContainer}
                                    />
                                )}
                            </div>
                            <div className="between-refer-line">
                                -{mustFillIn2}
                            </div>
                            <div className="endRefer between-refer-item">
                                {referDom || (
                                    <ReferLoader
                                        {...referConfig}
                                        {...data}
                                        {...queryCondition2}
                                        refRelyCondition={() => {
                                            return this.getCondition(
                                                data,
                                                searchInfo,
                                                this.context,
                                            );
                                        }}
                                        placeholder={data.placeholder}
                                        foolValue={{
                                            ...initialvalue,
                                            ...(isEmpty(VALUE[1])
                                                ? vv
                                                : VALUE[1]),
                                        }}
                                        onChange={that.betweenReferChangeEve.bind(
                                            that,
                                            '1',
                                            data,
                                        )}
                                        showTitle={false}
                                        // dropDownContainer={this.getItemPopContainer}
                                    />
                                )}
                            </div>
                        </div>
                    );
                } else {
                    let isOnchange = refData[0] ? '' : data.attrcode;
                    if (Array.isArray(refData?.value)) {
                        refData = {
                            value: refData.value[0],
                            display: refData.display && refData.display[0],
                        };
                    } else {
                        refData = {
                            value: refData?.value || '',
                            display: refData?.display || '',
                        };
                    }
                    let VALUE = getFunctionValueFromViewModal(
                        refData,
                        this.context,
                        isOnchange,
                    );
                    refDisplay = VALUE.display;
                    if (referDom) {
                        referDom = {
                            ...referDom,
                            props: {
                                // dropDownContainer: this.getItemPopContainer,
                                ...referDom.props,
                                ...data,
                                placeholder: data.placeholder,
                                foolValue: { ...initialvalue, ...VALUE },
                                onChange: that.referChangeEve.bind(that, data),
                                showTitle: false,
                            },
                        };
                    }
                    searchChildDom = (
                        <span className="search-dom">
                            {referDom || (
                                <ReferLoader
                                    {...referConfig}
                                    {...data}
                                    refRelyCondition={() => {
                                        return this.getCondition(
                                            data,
                                            searchInfo,
                                            this.context,
                                        );
                                    }}
                                    // dropDownContainer={this.getItemPopContainer}
                                    placeholder={data.placeholder}
                                    foolValue={{ ...initialvalue, ...VALUE }}
                                    onChange={that.referChangeEve.bind(
                                        that,
                                        data,
                                    )}
                                    showTitle={false}
                                />
                            )}
                        </span>
                    );
                }
                fieldTip =
                    refDisplay && data.label ? (
                        <span>
                            <b
                                className="tool-tip-label"
                                style={{ fontWeight: 'bold' }}
                            >
                                {data.label + '：'}
                            </b>
                            {refDisplay}
                        </span>
                    ) : (
                        ''
                    );
                if (
                    snapshotItem.operationSign !== 'between' &&
                    snapshotItem.operationSign !== 'not between'
                ) {
                    initialvalue.display = refDisplay;
                }
                break;
            case 'input':
                if (
                    snapshotItem.hasOwnProperty('operationSign') &&
                    (snapshotItem.operationSign === 'between' ||
                        snapshotItem.operationSign === 'not between')
                ) {
                    searchChildDom = (
                        <span className="search-dom">
                            <BetweenInput
                                disabled={!!disabled}
                                //isCheckChinese={!!data.maxlength}
                                mustFill={mustFillIn2}
                                onBlur={that.inputBlur.bind(
                                    that,
                                    data,
                                    'input',
                                )}
                                onChange={that.onInputChange.bind(that, data)}
                                //maxlength={Number(data.maxlength)}
                                placeholder={data.placeholder}
                                defaultPlaceholder={
                                    data.defaultPlaceholder || {
                                        start:
                                            data.label +
                                            multiLang['page-search-0078'],
                                        end:
                                            data.label +
                                            multiLang['page-search-0079'],
                                    }
                                }
                                value={val || []}
                                showClose={true}
                                watchPaste={true}
                            />
                        </span>
                    );
                } else {
                    searchChildDom = (
                        <span className="search-dom">
                            <FormControl
                                disabled={!!disabled}
                                value={val}
                                //isCheckChinese={!!data.maxlength}
                                onBlur={that.inputBlur.bind(
                                    that,
                                    data,
                                    'input',
                                )}
                                placeholder={data.placeholder}
                                onChange={that.onInputChange.bind(that, data)}
                                //maxlength={Number(data.maxlength)}
                                showClose={true}
                                watchPaste={true}
                            />
                        </span>
                    );
                }
                fieldTip =
                    !this.isTrueEmpty(val) && data.label ? (
                        <span>
                            <b
                                className="tool-tip-label"
                                style={{ fontWeight: 'bold' }}
                            >
                                {data.label + '：'}
                            </b>
                            {Array.isArray(val) ? val.join(',') : val}
                        </span>
                    ) : (
                        ''
                    );
                break;
            case 'select':
                if (val === '') {
                    val = undefined;
                }
                if (typeof val === 'string') {
                    val = val.split(',');
                }
                if (data.itemtype === 'radio') {
                    data.isMultiSelectedEnabled = false;
                }
                if (data.itemtype === 'checkbox') {
                    data.isMultiSelectedEnabled = true;
                }
                if (data.isMultiSelectedEnabled) {
                    //多选暂时这样，UE还没有出，后续再改
                    let options = data.options;
                    if (Array.isArray(options)) {
                        options = options.filter(
                            i => i.display !== '' && i.value !== '',
                        );
                    }
                    searchChildDom = (
                        <span className="search-dom">
                            <Select
                                disabled={!!disabled}
                                className="multiple-select"
                                multiple
                                getPopupContainer={this.getItemPopContainer}
                                // style={{ marginRight: 6 }}
                                placeholder={data.placeholder}
                                value={val}
                                listHeight={160}
                                onChange={that.onMultipleChange.bind(
                                    that,
                                    data,
                                )}
                                fieldid={data.attrcode}
                                supportSearch={data.supportSearch}
                                virtual={data.virtual}
                                required={data.required}
                                optionFilterProp="children"
                                maxTagCount={data.maxTagCount || 'auto'}
                            >
                                {options &&
                                    options.map((val, index) => {
                                        return (
                                            <Option key={index} value={String(val.value)}>
                                                {val.display}
                                            </Option>
                                        );
                                    })}
                            </Select>
                        </span>
                    );
                } else {
                    if (
                        snapshotItem.hasOwnProperty('operationSign') &&
                        (snapshotItem.operationSign === 'between' ||
                            snapshotItem.operationSign === 'not between')
                    ) {
                        searchChildDom = (
                            <span className="search-dom">
                                <NCSelectBetween
                                    disabled={!!disabled}
                                    showSearch
                                    style={{ marginRight: 6 }}
                                    placeholder={data.placeholder}
                                    value={val}
                                    listHeight={160}
                                    virtual={data.virtual}
                                    required={data.required}
                                    mustFill={mustFillIn2}
                                    getPopupContainer={this.getItemPopContainer}
                                    optionFilterProp="children"
                                    onChange={that.onSelectedBetweenChange.bind(
                                        that,
                                        data,
                                    )}
                                    fieldid={data.attrcode}
                                    options={data.options}
                                    maxTagCount={data.maxTagCount}
                                />
                            </span>
                        );
                    } else {
                        searchChildDom = (
                            <span className="search-dom">
                                <Select
                                    disabled={!!disabled}
                                    showSearch
                                    listHeight={160}
                                    virtual={data.virtual}
                                    // showClear={!data.required}
                                    getPopupContainer={this.getItemPopContainer}
                                    // style={{ marginRight: 6 }}
                                    placeholder={data.placeholder}
                                    value={val}
                                    required={data.required}
                                    optionFilterProp="children"
                                    onChange={that.onSelectedChange.bind(
                                        that,
                                        data,
                                    )}
                                    fieldid={data.attrcode}
                                    supportSearch={data.supportSearch}
                                >
                                    {data.options &&
                                        data.options.map((val, index) => {
                                            return (
                                                <Option
                                                    key={index}
                                                    value={String(val.value)}
                                                >
                                                    {val.display}
                                                </Option>
                                            );
                                        })}
                                </Select>
                            </span>
                        );
                    }
                }

                let tips = initialvalue.display;
                if (Array.isArray(data.options)) {
                    if (Array.isArray(val)) {
                        let arrOptionDisplay = [];
                        val.forEach(element => {
                            let opt = data.options.find(
                                item => item.value == element,
                            );
                            if (opt) {
                                arrOptionDisplay.push(opt.display);
                            }
                        });
                        tips = arrOptionDisplay.join(',');
                    } else {
                        let option = data.options.find(
                            item => item.value == val,
                        );
                        if (option) {
                            tips = option.display;
                        }
                    }
                }
                if (initialvalue && initialvalue.value === 'Y') {
                    tips = multiLang['page-search-0089'];
                } else if (initialvalue && initialvalue.value === 'N') {
                    tips = multiLang['page-search-0090'];
                }
                initialvalue.display = tips;
                fieldTip =
                    !this.isTrueEmpty(val) && data.label ? (
                        <span>
                            <b
                                className="tool-tip-label"
                                style={{ fontWeight: 'bold' }}
                            >
                                {data.label + '：'}
                            </b>
                            {tips}
                        </span>
                    ) : (
                        ''
                    );
                break;
            case 'datepicker':
                searchChildDom = (
                    <span className="search-dom">
                        <NCDatePicker
                            {...templetItem}
                            panelValue={this.Date}
                            isconverttimezones={isconverttimezones}
                            arrowKeyDownEnable
                            fieldid={data.attrcode}
                            disabled={!!disabled}
                            //format={format}
                            onSelect={that.onDateSelect}
                            onChange={that.onDateChange.bind(that, data)}
                            // locale={zhCN}
                            value={val}
                            // getPopupContainer={this.getItemPopContainer}
                            placeholder={data.placeholder}
                            operationSign={snapshotItem.operationSign}
                            showTimeFunction={showTimeFunction}
                            hiddenFunList={hiddenfunlist}
                            multiLang={multiLang}
                            LangData={LangData}
                            showClear={true}
                        />
                    </span>
                );
                if (val && val.indexOf('#') !== -1) {
                    timeValue = getFunctionDisplay(val, {
                        ...templetItem,
                        range: false,
                        multiLang,
                    });
                } else {
                    timeValue = val && formatDatetime(moment(val), 'date');
                }
                initialvalue.display = timeValue;
                fieldTip =
                    val && data.label ? (
                        <span>
                            <b
                                className="tool-tip-label"
                                style={{ fontWeight: 'bold' }}
                            >
                                {data.label + '：'}
                            </b>
                            {timeValue}
                        </span>
                    ) : (
                        ''
                    );
                break;
            case 'datetimepicker':
                if (
                    snapshotItem.hasOwnProperty('operationSign') &&
                    (snapshotItem.operationSign === 'between' ||
                        snapshotItem.operationSign === 'not between')
                ) {
                    if (Array.isArray(val)) {
                        let firstVal = val[0];
                        let secondVal = val[1];
                        if (isDateFunction(firstVal)) {
                            let firstArr = firstVal.split(' ');
                            if (firstArr.length === 1) {
                                firstVal += ' 00:00:00';
                                val[0] = firstVal;
                            }
                        }
                        if (isDateFunction(secondVal)) {
                            let secondArr = secondVal.split(' ');
                            if (secondArr.length === 1) {
                                secondVal += ' 23:59:59';
                                val[1] = secondVal;
                            }
                        }
                    }
                    searchChildDom = (
                        <span className="search-dom">
                            <NCDateTimePickerBetween
                                {...templetItem}
                                panelValue={this.Date}
                                arrowKeyDownEnable
                                isconverttimezones={isconverttimezones}
                                fieldid={data.attrcode}
                                disabled={!!disabled}
                                // separator={showLableFlag ? '~' : ' '}
                                className="search"
                                mustFill={mustFillIn2}
                                //format="YYYY-MM-DD HH:mm:ss"
                                onSelect={that.onDateSelect}
                                onChange={that.onDateTimeBetweenChange.bind(
                                    that,
                                    data,
                                )}
                                // locale={zhCN}
                                value={val}
                                // getPopupContainer={this.getItemPopContainer}
                                placeholder={[
                                    data.placeholder
                                        ? data.placeholder +
                                          multiLang['page-search-0039']
                                        : '',
                                    data.placeholder
                                        ? data.placeholder +
                                          multiLang['page-search-0040']
                                        : '',
                                ]}
                                showTimeFunction={showTimeFunction}
                                hiddenFunList={hiddenfunlist}
                                showClear={true}
                            />
                        </span>
                    );
                    timeValue = [];
                    for (var i = 0; i < val.length; i++) {
                        if (val[i]) {
                            if (val[i].indexOf('#') !== -1) {
                                let dis = getFunctionDisplay(val[i], {
                                    ...templetItem,
                                    range: true,
                                    multiLang,
                                })[i];
                                dis && timeValue.push(dis);
                            } else {
                                timeValue.push(
                                    formatDatetime(
                                        serverTimeToLocal(
                                            moment(val[i]),
                                            isconverttimezones,
                                        ),
                                        'datetime',
                                    ),
                                );
                            }
                        }
                    }
                    initialvalue.display = timeValue;
                    timeValue = timeValue.length ? timeValue.join('~') : '';
                } else {
                    if (typeof val === 'string' && isDateFunction(val)) {
                        let valArr = val.split(' ');
                        if (valArr.length === 1) {
                            val += ' 00:00:00';
                        }
                    }
                    searchChildDom = (
                        <span className="search-dom">
                            <NCTZDatePickClientTime
                                {...templetItem}
                                panelValue={this.Date}
                                arrowKeyDownEnable
                                isconverttimezones={isconverttimezones}
                                fieldid={data.attrcode}
                                disabled={!!disabled}
                                //format="YYYY-MM-DD HH:mm:ss"
                                onSelect={that.onDateSelect}
                                onChange={that.onDateChange.bind(that, data)}
                                // locale={zhCN}
                                value={val}
                                // getPopupContainer={this.getItemPopContainer}
                                placeholder={data.placeholder}
                                showTimeFunction={showTimeFunction}
                                hiddenFunList={hiddenfunlist}
                            />
                        </span>
                    );
                    if (val && val.indexOf('#') !== -1) {
                        timeValue = getFunctionDisplay(val, {
                            ...templetItem,
                            range: false,
                            multiLang,
                        });
                    } else {
                        timeValue =
                            val &&
                            formatDatetime(
                                serverTimeToLocal(
                                    moment(val),
                                    isconverttimezones,
                                ),
                                'datetime',
                            );
                    }
                    initialvalue.display = timeValue;
                }
                fieldTip =
                    !isEmpty(timeValue) && data.label ? (
                        <span>
                            <b
                                className="tool-tip-label"
                                style={{ fontWeight: 'bold' }}
                            >
                                {data.label + '：'}
                            </b>
                            {timeValue}
                        </span>
                    ) : (
                        ''
                    );
                break;
            case 'timepicker':
                if (
                    snapshotItem.hasOwnProperty('operationSign') &&
                    (snapshotItem.operationSign === 'between' ||
                        snapshotItem.operationSign === 'not between')
                ) {
                    searchChildDom = (
                        <span className="search-dom">
                            <RangePicker
                                {...templetItem}
                                picker="time"
                                // panelValue={this.Date}
                                fieldid={data.attrcode}
                                // arrowKeyDownEnable
                                isconverttimezones={isconverttimezones}
                                disabled={!!disabled}
                                // getPopupContainer={this.getItemPopContainer}
                                //format={Rangformat}
                                // onSelect={that.onDateSelect}
                                onChange={that.onRangDateChange.bind(
                                    that,
                                    data,
                                )}
                                value={this.isTrueEmpty(val) ? ['', ''] : val}
                                showClear={true}
                                // placeholder={data.placeholder || ' '}
                                dateInputPlaceholder={[
                                    data.placeholder
                                        ? data.placeholder +
                                          multiLang['page-search-0039']
                                        : '',
                                    data.placeholder
                                        ? data.placeholder +
                                          multiLang['page-search-0040']
                                        : '',
                                ]}
                                showTimeFunction={showTimeFunction}
                                hiddenFunList={hiddenfunlist}
                                multiLang={multiLang}
                                LangData={LangData}
                                onEnter={this.clickSearch}
                            />
                        </span>
                    );
                    timeValue = [];
                    if (Array.isArray(val)) {
                        for (var i = 0; i < val.length; i++) {
                            if (val[i]) {
                                timeValue.push(formatDatetime(val[i], 'time'));
                            }
                        }
                    }
                    initialvalue.display = timeValue;
                    timeValue = timeValue.length ? timeValue.join('~') : '';
                } else {
                    searchChildDom = (
                        <span className="search-dom">
                            <NCTimepicker
                                fieldid={data.attrcode}
                                arrowKeyDownEnable
                                disabled={!!disabled}
                                format="HH:mm:ss"
                                onSelect={that.onDateSelect}
                                onChange={that.onDateChange.bind(that, data)}
                                // locale={zhCN}
                                value={val}
                                getPopupContainer={this.getItemPopContainer}
                                placeholder={data.placeholder}
                                showTimeFunction={showTimeFunction}
                                hiddenFunList={hiddenfunlist}
                                onEnter={this.clickSearch}
                            />
                        </span>
                    );
                    timeValue = formatDatetime(val, 'time');
                }
                initialvalue.display = timeValue;
                fieldTip =
                    !this.isTrueEmpty(timeValue) && data.label ? (
                        <span>
                            <b
                                className="tool-tip-label"
                                style={{ fontWeight: 'bold' }}
                            >
                                {data.label + '：'}
                            </b>
                            {timeValue}
                        </span>
                    ) : (
                        ''
                    );
                break;
            case 'rangepicker':
                searchChildDom = (
                    <span className="search-dom">
                        <NCRangePicker
                            {...templetItem}
                            panelValue={this.Date}
                            fieldid={data.attrcode}
                            arrowKeyDownEnable
                            isconverttimezones={isconverttimezones}
                            disabled={!!disabled}
                            //format={Rangformat}
                            onSelect={that.onDateSelect}
                            onChange={that.onRangDateChange.bind(that, data)}
                            value={isEmpty(val) ? '' : val}
                            // getPopupContainer={this.getItemPopContainer}
                            showClear={true}
                            // placeholder={data.placeholder || ' '}
                            dateInputPlaceholder={[
                                data.placeholder
                                    ? data.placeholder +
                                      multiLang['page-search-0039']
                                    : '',
                                data.placeholder
                                    ? data.placeholder +
                                      multiLang['page-search-0040']
                                    : '',
                            ]}
                            showTimeFunction={showTimeFunction}
                            hiddenFunList={hiddenfunlist}
                            multiLang={multiLang}
                            LangData={LangData}
                            onEnter={this.clickSearch}
                        />
                    </span>
                );

                timeValue = [];
                for (var i = 0; i < val.length; i++) {
                    if (val[i]) {
                        if (val[i].indexOf('#') !== -1) {
                            let dis = getFunctionDisplay(val[i], {
                                ...templetItem,
                                range: true,
                                multiLang,
                            })[i];
                            dis && timeValue.push(dis);
                        } else {
                            timeValue.push(
                                formatDatetime(
                                    serverTimeToLocal(
                                        moment(val[i]),
                                        isconverttimezones,
                                    ),
                                    'date',
                                ),
                            );
                        }
                    }
                }
                initialvalue.display = timeValue;
                timeValue = timeValue.length ? timeValue.join('~') : '';
                fieldTip =
                    !isEmpty(timeValue) && data.label ? (
                        <span>
                            <b
                                className="tool-tip-label"
                                style={{ fontWeight: 'bold' }}
                            >
                                {data.label + '：'}
                            </b>
                            {timeValue}
                        </span>
                    ) : (
                        ''
                    );
                break;
            case 'datePickerNoTimeZone':
                searchChildDom = (
                    <span className="search-dom">
                        <NCDatePicker
                            {...templetItem}
                            panelValue={this.Date}
                            fieldid={data.attrcode}
                            arrowKeyDownEnable
                            disabled={!!disabled}
                            //format="YYYY-MM-DD"
                            onSelect={that.onDateSelect}
                            onChange={that.onDateChange.bind(that, data)}
                            // locale={zhCN}
                            value={val}
                            // getPopupContainer={this.getItemPopContainer}
                            placeholder={data.placeholder}
                            showTimeFunction={true}
                            hiddenFunList={hiddenfunlist}
                            showTime={false}
                            // onEnter={this.clickSearch}
                            showClear={true}
                        />
                    </span>
                );
                if (val && val.indexOf('#') !== -1) {
                    timeValue = getFunctionDisplay(val, {
                        ...templetItem,
                        range: false,
                        multiLang,
                    });
                } else {
                    timeValue = val && formatDatetime(moment(val), 'date');
                }
                fieldTip =
                    val && data.label ? (
                        <span>
                            <b
                                className="tool-tip-label"
                                style={{ fontWeight: 'bold' }}
                            >
                                {data.label + '：'}
                            </b>
                            {timeValue}
                        </span>
                    ) : (
                        ''
                    );
                break;
            case 'NCTZDatePickerStart':
                if (
                    snapshotItem.hasOwnProperty('operationSign') &&
                    (snapshotItem.operationSign === 'between' ||
                        snapshotItem.operationSign === 'not between')
                ) {
                    searchChildDom = (
                        <span className="search-dom">
                            <NCTZDatePickerStartBetween
                                {...templetItem}
                                panelValue={this.Date}
                                arrowKeyDownEnable
                                isconverttimezones={isconverttimezones}
                                fieldid={data.attrcode}
                                disabled={!!disabled}
                                // getPopupContainer={this.getItemPopContainer}
                                //format="YYYY-MM-DD HH:mm:ss"
                                onSelect={that.onDateSelect}
                                onChange={that.onDateTimeBetweenChange.bind(
                                    that,
                                    data,
                                )}
                                // locale={zhCN}
                                value={val}
                                placeholder={data.placeholder}
                                showTimeFunction={showTimeFunction}
                                hiddenFunList={hiddenfunlist}
                                showTime={false}
                                showToday={false}
                                onEnter={this.clickSearch}
                                showClear={true}
                            />
                        </span>
                    );
                } else {
                    searchChildDom = (
                        <span className="search-dom">
                            <NCTZDatePickerStart
                                {...templetItem}
                                panelValue={this.Date}
                                arrowKeyDownEnable
                                fieldid={data.attrcode}
                                disabled={!!disabled}
                                //format={data.format || 'YYYY-MM-DD HH:mm:ss'}
                                placeholder={data.placeholder}
                                value={val}
                                // getPopupContainer={this.getItemPopContainer}
                                onSelect={that.onDateSelect}
                                onChange={that.onDateChange.bind(that, data)}
                                showTimeFunction={showTimeFunction}
                                hiddenFunList={hiddenfunlist}
                                showToday={false}
                                showTime={false}
                                onEnter={this.clickSearch}
                                showClear={true}
                            />
                        </span>
                    );
                    if (val && val.indexOf('#') !== -1) {
                        timeValue = getFunctionDisplay(val, {
                            ...templetItem,
                            range: false,
                            singleValue: 'start',
                            multiLang,
                        });
                    } else {
                        timeValue =
                            val &&
                            formatDatetime(
                                serverTimeToLocal(
                                    moment(val),
                                    isconverttimezones,
                                ),
                                'date',
                            );
                    }
                }
                initialvalue.display = timeValue;
                fieldTip =
                    val && data.label ? (
                        <span>
                            <b
                                className="tool-tip-label"
                                style={{ fontWeight: 'bold' }}
                            >
                                {data.label + '：'}
                            </b>
                            {timeValue}
                        </span>
                    ) : (
                        ''
                    );
                break;
            case 'NCTZDatePickerRangeDay': //这种好像没用
                searchChildDom = (
                    <span className="search-dom">
                        <NCTZDatePickerRangeDay
                            {...templetItem}
                            panelValue={this.Date}
                            arrowKeyDownEnable
                            isconverttimezones={isconverttimezones}
                            fieldid={data.attrcode}
                            disabled={!!disabled}
                            //format={data.format || 'YYYY-MM-DD HH:mm:ss'}
                            placeholder={data.placeholder}
                            value={val}
                            // getPopupContainer={this.getItemPopContainer}
                            onSelect={that.onDateSelect}
                            onChange={that.onRangDateChange.bind(that, data)}
                            onEnter={this.clickSearch}
                            hiddenFunList={hiddenfunlist}
                        />
                    </span>
                );
                timeValue = [];
                for (var i = 0; i < val.length; i++) {
                    if (val[i]) {
                        if (val[i].indexOf('#') !== -1) {
                            let dis = getFunctionDisplay(val[i], {
                                ...templetItem,
                                range: true,
                                multiLang,
                            })[i];
                            dis && timeValue.push(dis);
                        } else {
                            timeValue.push(
                                formatDatetime(
                                    serverTimeToLocal(
                                        moment(val[i]),
                                        isconverttimezones,
                                    ),
                                    'date',
                                ),
                            );
                        }
                    }
                }
                timeValue = timeValue.length ? timeValue.join('~') : '';
                fieldTip =
                    !isEmpty(timeValue) && data.label ? (
                        <span>
                            <b
                                className="tool-tip-label"
                                style={{ fontWeight: 'bold' }}
                            >
                                {data.label + '：'}
                            </b>
                            {timeValue}
                        </span>
                    ) : (
                        ''
                    );
                break;
            case 'NCTZDatePickClientHourTime':
                searchChildDom = (
                    <span className="search-dom">
                        <NCTZDatePickClientHourTime
                            {...templetItem}
                            panelValue={this.Date}
                            arrowKeyDownEnable
                            isconverttimezones={isconverttimezones}
                            fieldid={data.attrcode}
                            disabled={!!disabled}
                            //format={data.format || 'YYYY-MM-DD HH:mm:ss'}
                            placeholder={data.placeholder || ''}
                            value={val}
                            // getPopupContainer={this.getItemPopContainer}
                            onSelect={that.onDateSelect}
                            onChange={that.onDateChange.bind(that, data)}
                            onEnter={this.clickSearch}
                            hiddenFunList={hiddenfunlist}
                        />
                    </span>
                );
                if (typeof val === 'string') {
                    if (val && val.indexOf('#') !== -1) {
                        timeValue = getFunctionDisplay(val, {
                            ...templetItem,
                            range: false,
                            multiLang,
                        });
                    } else {
                        timeValue =
                            val &&
                            formatDatetime(
                                serverTimeToLocal(
                                    moment(val),
                                    isconverttimezones,
                                ),
                                'date',
                            );
                    }
                }
                initialvalue.display = timeValue;
                fieldTip =
                    val && data.label ? (
                        <span>
                            <b
                                className="tool-tip-label"
                                style={{ fontWeight: 'bold' }}
                            >
                                {data.label + '：'}
                            </b>
                            {formatDatetime(timeValue, 'date')}
                        </span>
                    ) : (
                        ''
                    );
                break;
            case 'NCTZDatePickClientTime':
                searchChildDom = (
                    <span className="search-dom">
                        <NCTZDatePickClientTime
                            panelValue={this.Date}
                            arrowKeyDownEnable
                            isconverttimezones={isconverttimezones}
                            fieldid={data.attrcode}
                            disabled={!!disabled}
                            //format={data.format || 'YYYY-MM-DD HH:mm:ss'}
                            placeholder={data.placeholder || ''}
                            value={val}
                            // getPopupContainer={this.getItemPopContainer}
                            onSelect={that.onDateSelect}
                            onChange={that.onDateChange.bind(that, data)}
                            onEnter={this.clickSearch}
                            hiddenFunList={hiddenfunlist}
                        />
                    </span>
                );
                timeValue = initialvalue.display;
                fieldTip =
                    val && data.label ? (
                        <span>
                            <b
                                className="tool-tip-label"
                                style={{ fontWeight: 'bold' }}
                            >
                                {data.label + '：'}
                            </b>
                            {formatDatetime(timeValue, 'datetime')}
                        </span>
                    ) : (
                        ''
                    );
                break;
            case 'NCTZDatePickerEnd':
                if (
                    snapshotItem.hasOwnProperty('operationSign') &&
                    (snapshotItem.operationSign === 'between' ||
                        snapshotItem.operationSign === 'not between')
                ) {
                    searchChildDom = (
                        <span className="search-dom">
                            <NCTZDatePickerEndBetween
                                {...templetItem}
                                panelValue={this.Date}
                                arrowKeyDownEnable
                                isconverttimezones={isconverttimezones}
                                fieldid={data.attrcode}
                                disabled={!!disabled}
                                //format="YYYY-MM-DD HH:mm:ss"
                                onSelect={that.onDateSelect}
                                onChange={that.onDateTimeBetweenChange.bind(
                                    that,
                                    data,
                                )}
                                // locale={zhCN}
                                value={val}
                                // getPopupContainer={this.getItemPopContainer}
                                placeholder={data.placeholder}
                                showTimeFunction={showTimeFunction}
                                hiddenFunList={hiddenfunlist}
                                showTime={false}
                                showToday={false}
                                onEnter={this.clickSearch}
                                showClear={true}
                            />
                        </span>
                    );
                } else {
                    searchChildDom = (
                        <span className="search-dom">
                            <NCTZDatePickerEnd
                                {...templetItem}
                                panelValue={this.Date}
                                arrowKeyDownEnable
                                isconverttimezones={isconverttimezones}
                                fieldid={data.attrcode}
                                disabled={!!disabled}
                                //format={data.format || 'YYYY-MM-DD HH:mm:ss'}
                                placeholder={data.placeholder || ''}
                                value={val}
                                // getPopupContainer={this.getItemPopContainer}
                                onSelect={that.onDateSelect}
                                onChange={that.onDateChange.bind(that, data)}
                                showTimeFunction={showTimeFunction}
                                hiddenFunList={hiddenfunlist}
                                showTime={false}
                                showToday={false}
                                onEnter={this.clickSearch}
                                showClear={true}
                            />
                        </span>
                    );
                    if (val && val.indexOf('#') !== -1) {
                        timeValue = getFunctionDisplay(val, {
                            ...templetItem,
                            range: false,
                            singleValue: 'end',
                            multiLang,
                        });
                    } else {
                        timeValue =
                            val &&
                            formatDatetime(
                                serverTimeToLocal(
                                    moment(val),
                                    isconverttimezones,
                                ),
                                'date',
                            );
                    }
                }
                initialvalue.display = timeValue;
                fieldTip =
                    val && data.label ? (
                        <span>
                            <b
                                className="tool-tip-label"
                                style={{ fontWeight: 'bold' }}
                            >
                                {data.label + '：'}
                            </b>
                            {timeValue}
                        </span>
                    ) : (
                        ''
                    );
                break;
            case 'number':
                let dataScale = (data.initialvalue || {}).scale;
                let scale =
                    !isEmpty(dataScale) && dataScale != '-1'
                        ? dataScale
                        : data.scale;
                if (
                    snapshotItem.hasOwnProperty('operationSign') &&
                    (snapshotItem.operationSign === 'between' ||
                        snapshotItem.operationSign === 'not between')
                ) {
                    searchChildDom = (
                        <span className="search-dom">
                            <NCBetweenNum
                                {...templetItem}
                                disabled={!!disabled}
                                onChange={that.changeNumber.bind(that, data)}
                                onBlur={that.inputBlur.bind(
                                    that,
                                    data,
                                    'number',
                                )}
                                scale={Number(scale)}
                                mustFill={mustFillIn2}
                                max={
                                    that.checkNumberHandler(data)
                                        ? data.max
                                        : null
                                }
                                min={
                                    that.checkNumberHandler(data)
                                        ? data.min
                                        : null
                                }
                                //maxlength={Number(data.maxlength)}
                                placeholder={data.placeholder}
                                defaultPlaceholder={
                                    data.defaultPlaceholder || {
                                        start:
                                            data.label +
                                            multiLang['page-search-0078'],
                                        end:
                                            data.label +
                                            multiLang['page-search-0079'],
                                    }
                                }
                                value={val || []}
                            />
                        </span>
                    );
                } else {
                    searchChildDom = (
                        <span className="search-dom">
                            <NCNumber
                                {...templetItem}
                                disabled={!!disabled}
                                onBlur={that.inputBlur.bind(
                                    that,
                                    data,
                                    'number',
                                )}
                                scale={Number(scale)}
                                value={val}
                                //maxlength={Number(data.maxlength)}
                                placeholder={data.placeholder}
                                onChange={that.changeNumber.bind(that, data)}
                                max={
                                    that.checkNumberHandler(data)
                                        ? data.max
                                        : null
                                }
                                min={
                                    that.checkNumberHandler(data)
                                        ? data.min
                                        : null
                                }
                            />
                        </span>
                    );
                }
                fieldTip =
                    !this.isTrueEmpty(val) && data.label ? (
                        <span>
                            <b
                                className="tool-tip-label"
                                style={{ fontWeight: 'bold' }}
                            >
                                {data.label + '：'}
                            </b>
                            {this.trustString(val)}
                        </span>
                    ) : (
                        ''
                    );
                break;
            case 'checkbox':
                if (!val) {
                    val = [];
                }
                let checkboxOptions = [];
                if (Array.isArray(data.options)) {
                    data.options.forEach(i => {
                        checkboxOptions.push({
                            label: i.display,
                            value: String(i.value),
                        });
                    });
                }
                searchChildDom = (
                    <span className="search-dom">
                        <CheckboxGroup
                            options={checkboxOptions}
                            value={val}
                            onChange={that.onMultipleChange.bind(that, data)}
                        />
                    </span>
                );
                break;
            case 'radio':
                let options = data.options || [
                    { display: multiLang['page-search-0105'], value: '' },
                ];
                searchChildDom = (
                    <span className="search-dom">
                        <NCRadio.RadioGroup
                            name={data.label}
                            className="radioName"
                            selectedValue={String(val)}
                            onChange={this.radioChange.bind(that, data)}
                        >
                            {options.map((val, index) => {
                                return (
                                    <NCRadio
                                        disabled={!!disabled}
                                        key={index}
                                        value={String(val.value)}
                                    >
                                        {val.display ||
                                            multiLang['page-search-0105']}
                                    </NCRadio>
                                );
                            })}
                        </NCRadio.RadioGroup>
                    </span>
                );

                break;
            case 'checkbox_switch':
                let valueToBool =
                    typeof initialvalue.value === 'boolean'
                        ? initialvalue.value
                        : typeof initialvalue.value === 'string' &&
                          (initialvalue.value === 'false' ||
                              !initialvalue.value)
                            ? false
                            : true;
                initialvalue.value = valueToBool;
                searchChildDom = (
                    <span
                        className={`condition-item-contant checkbox ${
                            disabled ? 'disabled-checkbox' : ''
                        }`}
                        onClick={e =>
                            that.onChangeCheckbox_switch.call(that, data, e)
                        }
                        tabIndex={0}
                    >
                        <span className="switchSpan">{data.label} </span>
                        <NCCheckbox
                            disabled={!!disabled}
                            checked={valueToBool}
                            type="switch"
                            onClick={e =>
                                that.onChangeCheckbox_switch.call(that, data, e)
                            }
                        />
                    </span>
                );
                break;
            case 'switch':
                searchChildDom = (
                    <span
                        className={`condition-item-contant switch search-dom ${
                            disabled ? 'disabled-checkbox' : ''
                        }`}
                        onClick={that.switchChange.bind(that, data)}
                        tabIndex={0}
                    >
                        <span className="switchSpan">{data.label}</span>
                        <NCCheckbox
                            className="checkbox"
                            disabled={!!disabled}
                            checked={
                                typeof val === 'boolean'
                                    ? val
                                    : typeof val === 'string' &&
                                      (val === 'false' || !val)
                                        ? false
                                        : true
                            }
                            onClick={that.switchChange.bind(that, data)}
                        />
                    </span>
                );
                break;
            case 'password':
                let inputType = 'text';
                if (val) {
                    inputType = 'password';
                }
                searchChildDom = (
                    <span className="search-dom">
                        <div className="password_before">
                            <input type="text"></input>
                        </div>
                        <FormControl
                            disabled={!!disabled}
                            value={val}
                            onBlur={that.inputBlur.bind(that, data, 'password')}
                            placeholder={data.placeholder}
                            onChange={that.onInputChange.bind(that, data)}
                            //maxlength={data.maxlength}
                            type={inputType}
                        />
                    </span>
                );
                break;
            case 'residtxt':
                searchChildDom = (
                    <span className="search-dom">
                        {data.languageMeta && (
                            <NCMultiLangText
                                // key={this.searchPlanNum}
                                disabled={!!disabled}
                                getPopupContainer={this.getItemPopContainer}
                                value={snapshotItem.valueMap || {}}
                                LangIndex={
                                    snapshotItem?.initialvalue?.index || '1'
                                }
                                attrcode={data.attrcode}
                                //isCheckChinese={!!data.maxlength}
                                //maxlength={data.maxlength}
                                languageMeta={data.languageMeta}
                                // onBlur={that.inputBlur.bind(that, data, 'residtxt')}
                                placeholder={data.placeholder}
                                onSelect={that.onMultiLangTextSelect.bind(
                                    that,
                                    data,
                                )}
                                onChange={that.onMultiLangTextChange.bind(
                                    that,
                                    data,
                                )}
                            />
                        )}
                    </span>
                );
                fieldTip =
                    !isEmpty(val) && data.label ? (
                        <span>
                            <b
                                className="tool-tip-label"
                                style={{ fontWeight: 'bold' }}
                            >
                                {data.label + '：'}
                            </b>
                            {initialvalue.display}
                        </span>
                    ) : (
                        ''
                    );
                break;
            case 'custom':
                searchChildDom = (
                    <span className="search-dom">
                        {data.render(
                            that.onCustomChange.bind(that),
                            data,
                            initialvalue,
                        )}
                    </span>
                );
                fieldTip =
                    !isEmpty(val) && data.label ? (
                        <span>
                            <b
                                className="tool-tip-label"
                                style={{ fontWeight: 'bold' }}
                            >
                                {data.label + '：'}
                            </b>
                            {initialvalue.display}
                        </span>
                    ) : (
                        ''
                    );
                break;
        }
        let tip = (
            <div
                className="te-tips"
                style={{ fontSize: '13px', wordBreak: 'break-all' }}
            >
                {fieldTip}
            </div>
        );

        return (
            <TipsSearchItem
                data={data}
                showSearchLable={showSearchLable}
                showLableFlag={showLableFlag}
                tip={tip}
                fieldTip={fieldTip}
                showPlaceholder={this.showPlaceholder}
                mustFillInLable={mustFillInLable}
                snapshotItem={snapshotItem}
                mustFillIn1={mustFillIn1}
                searchChildDom={searchChildDom}
                multiLang={multiLang}
                setStateEve={this.setStateEve}
                onOperateTypeChange={this.onOperateTypeChange}
                onBeforeEvent={this.onBeforeEvent}
                underlineBorder={this.underlineBorder}
            />
        );
        // <div key={data.attrcode} onMouseEnter={() => { this.onHasEnter && this.onHasEnter(true); }} onMouseLeave={() => { this.onHasEnter && this.onHasEnter(true); }} onFocus={() => { this.onHasFocus && this.onHasFocus(true); }} onBlur={() => { this.onHasFocus && this.onHasFocus(false); }}>
        //     {Number(data.leftspace) ? <Col md={Number(data.leftspace)} xs={xs} sm={sm} /> : null}
        //     {showSearchLable && showLableFlag ? (<NCTooltip
        //         // delayShow={800}
        //         inverse
        //         className="search"
        //         overlay={tip}
        //         placement="top"
        //         trigger='hover'
        //         visible={fieldTip && this.showPlaceholder && data.attrcode !== this.focusAttrcode}
        //     >
        //         <div>
        //             <div className="searchTtem-area">
        //                 <span className="searchItem-lable" >{mustFillInLable}{data.label}</span>
        //                 {Array.isArray(snapshotItem.operationOptions) && snapshotItem.operationOptions.length > 1 && <Dropdown
        //                     trigger='click'
        //                     placement="bottomLeft"
        //                     overlayClassName='opr_dropdown'
        //                     overlay={(
        //                         <ul className="menu_items opr_menu">
        //                             {this.createOption(snapshotItem)}
        //                         </ul>
        //                     )}
        //                 >
        //                     <span className="oprOptionLable oprOptionLable-hover"> {this.createOprIcon(snapshotItem.operationSign)} <i className="iconfont oprOptionIcon icon-hangcaozuoxiala1" /></span>
        //                 </Dropdown>}
        //             </div>
        //             <div className="condition-contant">
        //                 {mustFillIn1}
        //                 {searchChildDom}
        //             </div>

        //         </div>
        //     </NCTooltip>) : (<NCTooltip
        //         // delayShow={800}
        //         inverse
        //         className="search"
        //         overlay={tip}
        //         placement="top"
        //         trigger='hover'
        //         visible={fieldTip && this.showPlaceholder && data.attrcode !== this.focusAttrcode}
        //     >
        //         <div className="condition-contant">
        //             {mustFillIn1}
        //             {searchChildDom}
        //         </div>
        //     </NCTooltip>)
        //     }
        //     {Number(data.rightspace) ? <Col md={Number(data.rightspace)} xs={xs} sm={sm} key={index} /> : null}
        // </div >
    }
}

export { templateEngine };
